import { render } from "./ProdutosView.vue?vue&type=template&id=32888e24&scoped=true"
import script from "./ProdutosView.vue?vue&type=script&lang=js"
export * from "./ProdutosView.vue?vue&type=script&lang=js"

import "./ProdutosView.vue?vue&type=style&index=0&id=32888e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32888e24"]])

export default __exports__